module.exports = __webpack_public_path__ + "static/media/dashboard-student-assignments.fc0b76e5.svg";